import styled from 'styled-components';

const CreditCardLogo = styled.img`
  border: 1px solid rgb(238, 238, 238);
  border-radius: 3px;
  ${({ width }) => `width: ${width || '1.75rem'}`};
`;

export default CreditCardLogo;
